import React, { ChangeEvent, useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { InitialState } from './types'
import * as actions from './actions'
import { useParams, Link } from 'react-router-dom'
import Modal from 'react-modal'
import { useAlert } from 'react-alert'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'

const customModalStyles = {
  content: {
    width: 590,
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
}

export default () => {
  const [relationModalIsOpen, setRelationModalIsOpen] = useState<boolean>(false)
  const [selectedModuleId, setSelectedModuleId] = useState<string>('')

  const selectCreateRef = useRef<HTMLSelectElement>(null)

  const { id } = useParams<{ id: string }>()
  const dispatch = useDispatch()
  const alert = useAlert()

  const { modules, isFetching, error } = useSelector(
    (state: { adminModulesList: InitialState }) => state.adminModulesList
  )

  useEffect(() => {
    if (error) {
      alert.error(error)
    }
  }, [error])

  useEffect(() => {
    dispatch(actions.fetchModulesList(id))
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  const handleRemoveModuleRelation = (relationId: string) => {
    dispatch(actions.removeModuleRelation(relationId, id))
  }

  const handleCreateRelation = (event: ChangeEvent<HTMLSelectElement>) => {
    const targetId = event.currentTarget.value
    dispatch(
      actions.createModuleRelation(id, selectedModuleId, targetId, 'blocks')
    )
    if (selectCreateRef.current) {
      selectCreateRef.current.value = 'add'
    }
  }

  const handleEditRelation = (
    event: ChangeEvent<HTMLSelectElement>,
    relationId: string
  ) => {
    const targetId = event.currentTarget.value
    dispatch(
      actions.editModuleRelation(
        id,
        relationId,
        selectedModuleId,
        targetId,
        'blocks'
      )
    )
  }

  return (
    <>
      <Header />
      <div className={'container'}>
        <h2>Панель администрирования - Список модулей</h2>
        <br />
        {isFetching ? (
          <span>Загрузка модулей...</span>
        ) : (
          <>
            <table>
              <thead>
                <tr>
                  <td>
                    <b>Название:</b>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {modules.map(module => (
                  <tr key={module.module_id}>
                    <td>
                      {module.title}{' '}
                      <a
                        style={{
                          borderBottom: '1px dashed blue',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          setSelectedModuleId(module.module_id)
                          setRelationModalIsOpen(true)
                        }}
                      >
                        (Зависимостей{' '}
                        {module.module_relations_blocks?.length || 0})
                      </a>{' '}
                    </td>
                    <td>
                      <Link
                        to={`/admin/courses/${id}/modules/${module.module_id}`}
                      >
                        Изменить
                      </Link>
                    </td>
                    <td>
                      <button
                        onClick={() =>
                          dispatch(actions.removeModule(module.module_id, id))
                        }
                        style={{ color: '#FFF', background: 'red' }}
                      >
                        X
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <br />
            <br />
            <Link to={`/admin/courses/${id}/modules/create`}>
              <button>Добавить модуль</button>
            </Link>
            <br />
            <br />
            {error ? <span style={{ color: 'red' }}>{error}</span> : null}
          </>
        )}
        <Modal
          isOpen={relationModalIsOpen}
          onRequestClose={() => setRelationModalIsOpen(false)}
          style={customModalStyles}
          ariaHideApp={false}
        >
          <h3 style={{ marginTop: 0 }}>Зависимости:</h3>
          <table>
            <thead>
              <tr>
                <td>
                  <b>Текущий модуль</b>
                </td>
                <td>
                  <b>Блокирует</b>
                </td>
                <td>
                  <b>Выбранный модуль</b>
                </td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {modules
                .find(module => module.module_id === selectedModuleId)
                ?.module_relations_blocks?.filter(
                  module => module.type === 'blocks'
                )
                ?.map((module, index, relations) => (
                  <tr key={module.module_relation_id}>
                    <td>
                      {
                        modules.find(
                          find => find.module_id === module.source_module_id
                        )?.title
                      }
                    </td>
                    <td>
                      <select value={'blocks'}>
                        <option value="blocks" disabled={true}>
                          Блокирует
                        </option>
                      </select>
                    </td>
                    <td>
                      <select
                        onChange={e =>
                          handleEditRelation(e, module.module_relation_id)
                        }
                      >
                        {modules.map(item => (
                          <option
                            value={item.module_id}
                            disabled={
                              item.module_id === module.source_module_id ||
                              relations.some(
                                rel => rel.target_module_id === item.module_id
                              )
                            }
                            selected={
                              module.target_module_id === item.module_id
                            }
                            key={item.module_id}
                          >
                            {item.title}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <button
                        style={{ color: '#FFF', background: 'red' }}
                        onClick={() =>
                          handleRemoveModuleRelation(module.module_relation_id)
                        }
                      >
                        X
                      </button>
                    </td>
                  </tr>
                ))}
              <tr>
                <td>
                  {
                    modules.find(find => find.module_id === selectedModuleId)
                      ?.title
                  }
                </td>
                <td>
                  <select value={'blocks'}>
                    <option value="blocks" disabled={true}>
                      Блокирует
                    </option>
                  </select>
                </td>
                <td>
                  <select ref={selectCreateRef} onChange={handleCreateRelation}>
                    <option value={'add'} selected={true} disabled={true}>
                      Выберите целевой урок
                    </option>
                    {modules.map(item => (
                      <option
                        value={item.module_id}
                        disabled={
                          item.module_id === selectedModuleId ||
                          modules
                            .find(
                              module => module.module_id === selectedModuleId
                            )
                            ?.module_relations_blocks?.filter(
                              module => module.type === 'blocks'
                            )
                            .some(
                              rel => rel.target_module_id === item.module_id
                            )
                        }
                        key={item.module_id}
                      >
                        {item.title}
                      </option>
                    ))}
                  </select>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </Modal>
      </div>
      <Footer />
    </>
  )
}
